import { useEffect, useState } from 'react';

import transformAlgoliaRecipes from '@/server/repository/algolia/transformer/Recipes/AlgoliaRecipesTransformer';
import { ICarouselData } from 'components/CardCarousel/types';
import { ISuggestedData } from 'components/Cards/types';
import { getAlgoliaExtensionData } from 'server/repository/algolia/requests/getAlgoliaExtensionData';
import type { PathTranslations } from 'service/localization/getPathTranslations';
import { RelatedDataService } from 'service/relatedData/relatedDataService';

export const useAlgoliaExtensionCardData = (
  data?: ICarouselData,
  length?: number,
  pathTranslations?: PathTranslations,
) => {
  const [cardData, setCardData] = useState<ISuggestedData[]>();

  useEffect(() => {
    if (data && length && pathTranslations) {
      getAlgoliaExtensionData(data, length).then((results) => {
        if (!results) return;
        const { hits, queryID } = results;
        const transformedData = transformAlgoliaRecipes(hits, queryID);
        const parsedCardData = RelatedDataService.getRelatedData(
          transformedData,
          pathTranslations,
          data?.cardVariation || 'recipe',
        );
        setCardData(parsedCardData);
      });
    }
  }, []);
  return cardData;
};
